import { render } from "./filter-item.vue?vue&type=template&id=4db4abc0&scoped=true"
import script from "./filter-item.vue?vue&type=script&lang=js"
export * from "./filter-item.vue?vue&type=script&lang=js"

import "./filter-item.vue?vue&type=style&index=0&id=4db4abc0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db4abc0"]])

export default __exports__